var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-mobile-container"
  }, [_vm.props.payload.nodeStatus !== 2 ? _c('div', {
    staticClass: "before-form"
  }, [_c('Icon', {
    staticStyle: {
      "margin": "5px 4px"
    },
    attrs: {
      "src": _vm.iconForm,
      "width": "60px",
      "height": "60px"
    }
  }), _c('div', {
    class: _vm.props.payload.nodeStatus === 1 ? 'form-button-disable' : 'form-button',
    on: {
      "click": _vm.clickShowDialog
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.立即填写")) + " ")])], 1) : _vm._e(), _c('div', {
    staticClass: "edit-form"
  }, [_c('div', {
    staticClass: "edit-form-item"
  }, [_c('FormPopup', {
    staticClass: "form-item",
    attrs: {
      "show": _vm.showDialog,
      "showHeaderCloseButton": false,
      "title": ""
    },
    on: {
      "onClose": _vm.closeDialog
    }
  }, [_c('div', {
    staticClass: "dialog-container"
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_c('div', {
    staticClass: "dialog-title-tip"
  }, [_vm._v(" " + _vm._s(_vm.props.payload.content.tip) + " ")]), _c('div', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('Icon', {
    attrs: {
      "src": _vm.iconClose,
      "width": "16px",
      "height": "16px"
    }
  })], 1)]), _c('div', {
    staticClass: "dialog-show-content"
  }, _vm._l(_vm.props.payload.content.inputVariables, function (item, index) {
    return _c('div', {
      key: index
    }, [item.formType == 0 && _vm.props.payload.nodeStatus == 0 ? _c('div', [_c('InputMobile', {
      attrs: {
        "placeholder": item.placeholder,
        "variableValue": item.variableValue,
        "name": item.name,
        "isRequired": item.isRequired,
        "validator": item.isRequired == 1 && _vm.isValid(item.name)
      },
      on: {
        "input-change": _vm.handleInputChange
      }
    })], 1) : item.formType == 1 && _vm.props.payload.nodeStatus == 0 ? _c('div', [_c('RadioMobile', {
      attrs: {
        "chooseItemList": item.chooseItemList,
        "name": item.name,
        "isRequired": item.isRequired,
        "validator": item.isRequired == 1 && _vm.isValid(item.name)
      },
      on: {
        "input-change": _vm.handleInputChange
      }
    })], 1) : _c('div', {
      staticClass: "variable-value-container-mobile"
    }, [_c('div', {
      staticClass: "variable-value-label-mobile"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('div', {
      staticClass: "variable-value"
    }, [_vm._v(" " + _vm._s(item.variableValue == '' || item.variableValue == null ? _vm.mapValue[item.name] : item.variableValue) + " ")])])]);
  }), 0), _vm.props.payload.nodeStatus === 0 ? _c('div', {
    staticClass: "button-container"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.handleSendForm
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.提交")) + " ")])]) : _vm._e()])])], 1)]), _vm.props.payload.nodeStatus == 2 ? _c('div', {
    staticClass: "before-form"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('Icon', {
    staticClass: "form-icon",
    staticStyle: {
      "margin": "5px 4px"
    },
    attrs: {
      "src": _vm.iconForm,
      "width": "60px",
      "height": "60px"
    }
  }), _vm.props.payload.nodeStatus == 2 ? _c('Icon', {
    staticClass: "form-icon-check",
    attrs: {
      "width": "26px",
      "height": "26px",
      "src": _vm.iconFormFilled
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "form-button",
    on: {
      "click": _vm.clickShowDialog
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.查看内容")) + " ")])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }